import { collection, getDocs } from "firebase/firestore";

import { fieldNames } from "./constants";
import { db } from "./firebase";
import { isError } from "../actions/errorActions";
import { isLoading } from "../actions/loadingActions";

const { PUBLISH, PREVIEW } = fieldNames;

export function fetchLegislators({ governmentBody, addLegislatorAction }) {
  return async function (dispatch) {
    dispatch(isLoading(true));

    try {
      //This will go into each gov body collection in firestore and get all documents
      const legislatorsRef = collection(db, governmentBody);
      const querySnapshot = await getDocs(legislatorsRef);

      //Converts firestore docs into our familiar airtable format
      const legislatorData = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        fields: doc.data(),
      }));

      const publishedLegislators = legislatorData.filter((person) => {
        return person.fields[PUBLISH];
      });

      const previewLegislators = legislatorData.filter(
        (person) => person.fields[PREVIEW],
      );

      if (governmentBody?.toLowerCase().includes("preview")) {
        dispatch(addLegislatorAction(previewLegislators));
      } else {
        dispatch(addLegislatorAction(publishedLegislators));
      }

      dispatch(isError(false));
      dispatch(isLoading(false));
    } catch (error) {
      console.error("Firestore fetch error:", error);
      dispatch(isLoading(false));
      dispatch(isError(true));
    }
  };
}

//All Redux action creators
export function addSenators(senators) {
  return {
    type: "FETCH_SENATE",
    payload: senators,
  };
}

export function addAssemblymembers(assemblymembers) {
  return {
    type: "FETCH_ASSEMBLY",
    payload: assemblymembers,
  };
}

export function addCouncilMembers(councilmembers) {
  return {
    type: "FETCH_COUNCIL",
    payload: councilmembers,
  };
}

export function addNassauLeg(legislators) {
  return {
    type: "FETCH_NASSAU",
    payload: legislators,
  };
}

export function addSuffolkLeg(legislators) {
  return {
    type: "FETCH_SUFFOLK",
    payload: legislators,
  };
}

export function addDutchessLeg(legislators) {
  return {
    type: "FETCH_DUTCHESS",
    payload: legislators,
  };
}

export function addOrangeLeg(legislators) {
  return {
    type: "FETCH_ORANGE",
    payload: legislators,
  };
}

export function addPutnamLeg(legislators) {
  return {
    type: "FETCH_PUTNAM",
    payload: legislators,
  };
}

export function addUlsterLeg(legislators) {
  return {
    type: "FETCH_ULSTER",
    payload: legislators,
  };
}

export function addWestchesterLeg(legislators) {
  return {
    type: "FETCH_WESTCHESTER",
    payload: legislators,
  };
}

export function addBuffaloLeg(legislators) {
  return {
    type: "FETCH_BUFFALO",
    payload: legislators,
  };
}

export function addErieLeg(legislators) {
  return {
    type: "FETCH_ERIE",
    payload: legislators,
  };
}

export function addRochesterLeg(legislators) {
  return {
    type: "FETCH_ROCHESTER",
    payload: legislators,
  };
}

export function addMonroeLeg(legislators) {
  return {
    type: "FETCH_MONROE",
    payload: legislators,
  };
}

export function addNiagaraLeg(legislators) {
  return {
    type: "FETCH_NIAGARA",
    payload: legislators,
  };
}
